export { default, type ITooltipProps } from "./withTooltip";
